import type { FormProps } from '../../types'
import style from '../form.module.css'

export interface EmailInput {
  name: string
  type: string
  customControlType: 'email'
  value?: string
  uiOptions?: {
    placeholder?: string
    testId?: string
    disabled?: boolean
  }
  validation?: {
    required?: boolean
  }
}

export default function CustomEmail({
  field,
  formProps,
}: {
  field: EmailInput
  formProps: FormProps
}) {
  return (
    <input
      type="email"
      placeholder={field.uiOptions?.placeholder ?? 'email@example.com'}
      className={style.customInput}
      {...formProps?.register(field.name, {
        value: field.value,
      })}
      data-testid={field.uiOptions?.testId}
      disabled={field.uiOptions?.disabled}
    />
  )
}
